<div style="display:show" id="divdata">
    <div class="b-b pb-2 w-100 mb-3 float-left align-v-center">
        <h5 class="medium m-0" *ngIf="type == 'ADD'"> {{'addJobCat' | translate}}</h5>
        <h5 class="medium m-0" *ngIf="type == 'EDIT'">{{'editJobCat' | translate}} </h5>
        <h5 class="medium m-0" *ngIf="type == 'DELETE'">{{'deleteJobCat' | translate}} </h5>
        <div class="ml-alert">
        </div>
        <div style="flex-grow: 1;"></div>
        <button class="btn btn-secondary" name="backFrmEmpType" (click)="goToBackPage()">
            <i class="fa fa-arrow-left mr-sm-2"></i> {{'back' | translate}}
        </button>
    </div>
    <div class="col-lg-8 col-md-3">
        <div class="form-group">
            <label> {{'code' | translate}}
                <span class="text-danger medium">*</span>
            </label>
            <input type="text" class="form-control" name="empTypeCode" placeholder="{{'code' | translate}}"
                   [(ngModel)]="empTypedata.code"
                   [readonly]="type == 'DELETE'" maxlength="250">
            <span class="info-text">({{'maxTwoFifty' | translate}})</span>
        </div>
    </div>
    <div class="col-lg-8 col-md-3">
        <div class="form-group">
            <label> {{'name' | translate}}
                <span class="text-danger medium">*</span>
            </label>
            <input type="text" class="form-control" name="empTypeName" placeholder="{{'name' | translate}}"
                   [(ngModel)]="empTypedata.type"
                   [readonly]="type == 'DELETE'" maxlength="250">
            <span class="info-text">({{'maxTwoFifty' | translate}})</span>
        </div>
    </div>
    <div class="col-lg-8 col-md-3">
        <div class="form-group">
            <label> {{'nameLocale' | translate}}
            </label>
            <input type="text" class="form-control" name="empTypeNameLoc" placeholder="{{'nameLocale' | translate}}"
                   [(ngModel)]="empTypedata.typeLocale"
                   [readonly]="type == 'DELETE'" maxlength="250">
            <span class="info-text">({{'maxTwoFifty' | translate}})</span>
        </div>
    </div>
    <div class="col-lg-8 col-md-3">
        <div class="form-group">
            <label> {{'description' | translate}}
            </label>
            <input type="text" class="form-control" name="empTypeDes" placeholder="{{'description' | translate}}"
                   [(ngModel)]="empTypedata.description"
                   [readonly]="type == 'DELETE'" maxlength="500">
            <span class="info-text">({{'maxFiveHundred' | translate}})</span>
        </div>
    </div>
    <div class="col-lg-8 col-md-3">
        <div class="form-group">
            <label> {{'descriptionLocale' | translate}}
            </label>
            <input type="text" class="form-control" name="empTypeDesLoc"
                   placeholder="{{'descriptionLocale' | translate}}" [(ngModel)]="empTypedata.descriptionLocale"
                   [readonly]="type == 'DELETE'" maxlength="500">
            <span class="info-text">({{'maxFiveHundred' | translate}})</span>
        </div>
    </div>
    <div class="col-lg-8 col-md-3">
        <div class="form-group">
            <label> {{'level' | translate}}
                <span class="text-danger medium">*</span>
            </label>
            <input type="number" class="form-control" name="empTypeLev" placeholder="{{'level' | translate}}"
                   [(ngModel)]="empTypedata.level"
                   min="1" [readonly]="type == 'DELETE'"
                   onkeypress="return event.charCode >= 48  && event.charCode != 69 && event.charCode != 101"
                   max="100">
        </div>
    </div>

    <div class="col-lg-8 col-md-3" *ngIf="type == 'DELETE' && empPresent">
        <div class="form-group">
            <label for="empTypeModel">{{'altJobCat' | translate}}</label>
            <input ng2-auto-complete autocomplete="off" [(ngModel)]="empTypeModel" name="empTypeModel"
                   [source]="categoryObservableSource.bind(this)"
                   [list-formatter]="autoCompleteListCategoryFormatter" value-property-name="id"
                   display-property-name="displayName"
                   placeholder="{{'typeChooseJobCat' | translate}}" class="form-control"
                   (valueChanged)="gotNewValue($event)"
                   max-num-list=5 [value-formatter]="nameValueFormatter" blank-option-text="Select"
                   [accept-user-input]=false
                   [no-match-found-text]="warning">
            <span class="info-text"> {{'selectJobCat' | translate}} </span>
        </div>
    </div>
    <div class="col-lg-3 col-md-3">

        <button class="btn btn-primary float-left mt-4" *ngIf="type == 'ADD'" name="addEmpTyp"
                (click)=this.saveCategory()> {{'add' |
            translate}}
        </button>
        <button class="btn btn-primary float-left mt-4" name="editEmpTyp" *ngIf="type == 'EDIT'"
                (click)=this.saveCategory()>
            {{'updateChanges' | translate}}
        </button>
        <button class="btn btn-primary float-left mt-4" name="deleteEmpType" *ngIf="type == 'DELETE'"
                (click)=this.deleteCategory()> {{'delete'
            | translate}}
        </button>
        <button class="btn btn-secondary float-left mt-4 ml-1" name="empTypeCancel" (click)="goToBackPage()"> {{'cancel'
            | translate}}
        </button>

    </div>

</div>


// WEBPACK FOOTER //
// ./src/app/tools/addEmpType.html